import { KTSVG } from '_metronic/helpers'
import WorkOpeningNoticeForm from './Components/WorkOpeningNoticeForm'
import useViewModel from './ViewModel'

const WorkOpeningNoticeView: React.FC = () => {
  const vm = useViewModel()

  if (vm.loading) {
    return (
      <div className='d-flex justify-content-center py-20'>
        <div className='spinner-border text-primary' role='status'>
          <span className='visually-hidden'>Loading...</span>
        </div>
      </div>
    )
  }

  return (
    <div className='row gy-5'>
      <div className='col-12'>
        <div className='card'>
          <div className='card-footer text-center text-lg-end'>
            <button
              type='button'
              disabled={vm.loading || vm.downloading}
              onClick={vm.onDownloadPdf}
              className='btn btn-sm btn-secondary fw-bold me-4'>
              <KTSVG
                path='/media/icons/duotune/files/fil017.svg'
                className='svg-icon svg-icon-1x svg-icon-primary'
              />
              พิมพ์เอกสาร
            </button>
            {!vm.isView && (
              <button
                className='btn btn-sm btn-primary fw-bold w-sm-100'
                type='button'
                disabled={vm.saving}
                onClick={vm.save}>
                {vm.saving ? 'กำลังบันทึก...' : 'บันทึก'}
              </button>
            )}
          </div>
        </div>
      </div>

      <WorkOpeningNoticeForm vm={vm} />
    </div>
  )
}

export default WorkOpeningNoticeView
